const MentorSession = () => {
  return <>Mentor Session Page</>;
};

export default MentorSession;
